// extracted by mini-css-extract-plugin
export default {"pageTitle":"error_pageTitle__5yLHU","siteWidth":"error_siteWidth__Fh4ee","errorPanel":"error_errorPanel__Mqo84"};